/* Quadrajet Power — live search suggestions under the header search box.
   Queries the storefront's full search via the alternate "suggest" view
   (templates/search.suggest.liquid), so dropdown matches include titles,
   tags, SKUs AND descriptions, with no 10-result API cap (shows up to 20,
   scrollable). Wholesale-tagged customers see struck retail + wholesale
   price on eligible parts (ws_price from the suggest view). No app needed. */
(function () {
  'use strict';
  var forms = document.querySelectorAll
    ? document.querySelectorAll('.header-search')
    : [document.querySelector('.header-search')];
  if (!forms.length || !window.fetch) return;

  var style = document.createElement('style');
  style.textContent = '.search-suggest__list{max-height:min(60vh,520px);overflow-y:auto}.search-suggest__price .ws-retail{color:#999;font-weight:400;margin-right:6px}';
  document.head.appendChild(style);

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  Array.prototype.forEach.call(forms, function (form) {
    if (!form) return;
    var input = form.querySelector ? form.querySelector('input[name="q"]') : document.getElementById('HeaderSearch');
    if (!input) return;

    var box = document.createElement('div');
    box.className = 'search-suggest';
    box.hidden = true;
    form.appendChild(box);

    var timer = null;
    var lastQuery = '';
    var seq = 0;

    function close() {
      box.hidden = true;
      box.innerHTML = '';
    }

    function render(q, total, products) {
      if (!products.length) {
        box.innerHTML = '<div class="search-suggest__empty">No matches for “' + esc(q) + '” — press Enter to search everything.</div>';
        box.hidden = false;
        return;
      }
      var items = products.map(function (p) {
        var img = p.image
          ? '<img src="' + esc(p.image) + '" alt="" width="40" height="30" loading="lazy">'
          : '';
        var priceHtml = p.ws_price
          ? '<s class="ws-retail">$' + esc(p.price) + '</s><span class="ws-now">$' + esc(p.ws_price) + '</span>'
          : esc(p.price ? '$' + p.price : '');
        return '<a class="search-suggest__item" href="' + esc(p.url) + '">' + img +
          '<span class="search-suggest__meta">' +
          '<span class="search-suggest__title">' + esc(p.title) + '</span>' +
          '<span class="search-suggest__price">' + priceHtml + '</span>' +
          '</span></a>';
      }).join('');
      var allLabel = total > products.length
        ? 'See all ' + total + ' results for “' + esc(q) + '” →'
        : 'See all results for “' + esc(q) + '” →';
      box.innerHTML = '<div class="search-suggest__list">' + items + '</div>' +
        '<a class="search-suggest__all" href="/search?type=product&q=' + encodeURIComponent(q) + '">' + allLabel + '</a>';
      box.hidden = false;
    }

    function query(q) {
      var mySeq = ++seq;
      fetch('/search?view=suggest&type=product&q=' + encodeURIComponent(q))
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (data) {
          if (mySeq !== seq) return;
          var products = (data && data.products) || [];
          products = products.filter(function (p) {
            return p.url.indexOf('/products/package-protection') === -1;
          });
          render(q, (data && data.total) || products.length, products);
        })
        .catch(function () { if (mySeq === seq) close(); });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { lastQuery = ''; close(); return; }
      timer = setTimeout(function () {
        if (q === lastQuery && !box.hidden) return;
        lastQuery = q;
        query(q);
      }, 200);
    });

    input.addEventListener('focus', function () {
      var q = input.value.trim();
      if (q.length >= 2) query(q);
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !box.hidden) { close(); input.blur(); }
    });
  });
})();
